module.exports = __webpack_public_path__ + "media/assets/icons/person-white-13625dac227cf2f4dfe2eeeac91a45ca.svg";